export default "__VITE_ASSET__C9jLYOP3__"